import * as fromSchoolSearch from '../actions/reports-school-search.action';
import * as fromModels from '../../../scp/search/models/school-search-criteria.model';

export interface ReportsSchoolSearchState {
  searchCriteria: fromModels.SchoolSearchCriteria;
}

export const initialState: ReportsSchoolSearchState = {
  searchCriteria: {
    callDay: 'Any',
    code: '',
    county: '',
    districtId: null,
    districtName: '',
    gradeLevel: 'Any',
    id: null,
    isActive: 'true',
    longName: '',
    offersBandshare: 'Any',
    phone: '',
    primaryFulfillmentSite: '',
    radius: 5,
    schoolType: 'Any',
    state: 'Any',
    zip: '',
  }
};

export function reducer(state = initialState, action: fromSchoolSearch.ReportsSchoolSearchActions): ReportsSchoolSearchState {
  switch (action.type) {
    case fromSchoolSearch.ReportsSchoolSearchActionTypes.ExecuteReportSearch: {
      const searchCriteria = action.payload;

      return {
        ...updateSchoolSearchState(state, searchCriteria)
      };
    }
    default:
      return state;
  }
}

function updateSchoolSearchState(state: ReportsSchoolSearchState, searchCriteria: fromModels.SchoolSearchCriteria) {
  return {
    ...state,
    searchCriteria
  };
}

export const getSchoolSearchCriteria = (state: ReportsSchoolSearchState) => state.searchCriteria;
